import { ActivityPluginRegistry } from "../../registry/ActivityPluginRegistry";
import { MessageTypes } from "../../../entities/ActivityTypes";
import { ActivityEmailCard } from "./ActivityEmailCard";

ActivityPluginRegistry.register({
  key: "1:1",
  matches: (item) => item.Entity === 1 && item.Type === MessageTypes.Mail,
  Component: ActivityEmailCard
});
